import SVGIcon from 'components/presenters/common/SVGIcon'
import React from 'react'
import styled from 'styled-components'
import constants from 'utils/constants'

export default function CommerceChallengeTutorialList() {
  return (
    <TutorialBlock>
      <TutorialWrapper>
        <TutorialTitle>
          건강제품을 사놓고
          <br />
          방치하는 경우, 많지 않나요?
        </TutorialTitle>
        <TutorialDesc>꾸준한 건강습관도 만들고 환급까지 받으세요!</TutorialDesc>
        <TutorialImg
          src={`${constants.imagePath}/commerce/tutorial/motishop_tutorial_1-1005x993.jpg`}
        />
        <ShortDesc style={{ textAlign: 'right' }}>*환급액은 제품마다 상이</ShortDesc>
      </TutorialWrapper>
      <TutorialWrapper style={{ marginBottom: 'calc(100vw * (19 / 375))' }}>
        <TutorialTitle style={{ marginBottom: 'calc(100vw * (20 / 375))' }}>
          제품 구매 이후,
          <br />
          어떻게 인증하나요?
        </TutorialTitle>
        <TutorialImg
          src={`${constants.imagePath}/commerce/tutorial/motishop_tutorial_2-1005x1311.png`}
        />
        <ShortDesc>* 인증기간, 성공조건은 제품 소개페이지에서 확인 </ShortDesc>
      </TutorialWrapper>
      <NoticeInfo>
        <NoticeInfoIconWrapper>
          <SVGIcon name="infoCircleIcon" />
        </NoticeInfoIconWrapper>
        배송완료 후, 7일 이내 인증시작 버튼을 눌러야 환급 가능해요!
      </NoticeInfo>
    </TutorialBlock>
  )
}

const TutorialBlock = styled.div`
  width: 100%;
`
const TutorialWrapper = styled.div`
  margin-bottom: calc(100vw * (50 / 375));
`
const TutorialTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  line-height: 149.99%;
  color: #121212;
  margin-bottom: calc(100vw * (8 / 375));
`
const TutorialDesc = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: calc(100vw * (14 / 375));
  line-height: 149.99%;
  color: #4e4e4e;
  margin-bottom: calc(100vw * (32 / 375));
`
const TutorialImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
`

const ShortDesc = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (14 / 375));
  color: #888888;
  margin-top: calc(100vw * (10 / 375));
`

const NoticeInfo = styled.div`
  position: relative;
  padding: calc(100vw * (12 / 375)) calc(100vw * (32 / 375)) calc(100vw * (12 / 375))
    calc(100vw * (40 / 375));
  background: #fbfbfb;
  border: 1px solid #e0e3ed;
  border-radius: calc(100vw * (10 / 375));
  margin-bottom: calc(100vw * (51 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (21 / 375));
  color: #7f7f7f;
`
const NoticeInfoIconWrapper = styled.div`
  position: absolute;
  left: calc(100vw * (15 / 375));
  top: calc(100vw * (15 / 375));
  display: inline-block;
  width: calc(100vw * (17 / 375));
  height: calc(100vw * (17 / 375));

  svg {
    color: #7f7f7f;
  }
`
